<template>
  <div class="min-h-screen bg-gray-50 p-8 font-sans text-gray-800">
    <div class="mx-auto max-w-4xl rounded-2xl bg-white p-8 shadow-xl ring-1 ring-gray-100">

      <div class="mb-8 border-b border-gray-100 pb-5">
        <button
            type="button" @click="gotoDash"
            class="flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-1.5 font-medium text-gray-700 shadow-sm transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
          <svg
              xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-gray-500" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="2"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
          </svg>

          Back
        </button>
        <h2 class="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-2xl font-bold text-transparent">
          Edit Profile
        </h2>
      </div>

      <form @submit.prevent="createEnq" class="space-y-6">

        <div class="grid grid-cols-1 gap-6 md:grid-cols-2">

          <div>
            <label for="sunrackCode" class="block text-sm font-medium text-gray-700">Sunrack Code <span
                class="text-red-500">*</span></label>
            <input
                type="text"
                id="sunrackCode"
                v-model="formData.sunrackCode"
                required
                placeholder="e.g., SR-1045"
                class="mt-1 block w-full rounded-lg border border-gray-300 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
          </div>

          <div>
            <label for="genericName" class="block text-sm font-medium text-gray-700">Generic Name <span
                class="text-red-500">*</span></label>
            <input
                type="text"
                id="genericName"
                v-model="formData.genericName"
                required
                placeholder="e.g., Big Rail Nut"
                class="mt-1 block w-full rounded-lg border border-gray-300 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
          </div>

          <div class="md:col-span-2">
            <label for="profileName" class="block text-sm font-medium text-gray-700">Profile Name <span
                class="text-red-500">*</span></label>
            <input
                type="text"
                id="profileName"
                v-model="formData.profileName"
                required
                placeholder="e.g., Rail Nut"
                class="mt-1 block w-full rounded-lg border border-gray-300 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
          </div>

          <div>
            <label for="unitWeight" class="block text-sm font-medium text-gray-700">Unit Weight (kg/m) <span
                class="text-red-500">*</span></label>
            <input
                type="number"
                step="0.01"
                id="unitWeight"
                v-model="formData.unitWeight"
                required
                placeholder="0.00"
                class="mt-1 block w-full rounded-lg border border-gray-300 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
          </div>

          <div>
            <label for="extruderCode" class="block text-sm font-medium text-gray-700">Extruder Code</label>
            <input
                type="text"
                id="extruderCode"
                v-model="formData.extruderCode"
                placeholder="e.g., EXT-A01"
                class="mt-1 block w-full rounded-lg border border-gray-300 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
          </div>

          <div>
            <label for="status" class="block text-sm font-medium text-gray-700">Profile Status</label>
            <select
                id="status"
                v-model="formData.status"
                class="mt-1 block w-full rounded-lg border border-gray-300 bg-gray-50 px-4 py-2.5 text-sm text-gray-900 focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
              <option value="Redevlopment">Redevlopment</option>
            </select>
          </div>

          <div>
            <label for="profileImage" class="block text-sm font-medium text-gray-700">
              Profile Image <span class="text-xs text-gray-400">(jpg, png)</span>
            </label>

            <div v-if="existingFiles.profileImage" class="mt-1 mb-2 text-sm text-gray-600">
              Current file:
              <a :href="existingFiles.profileImage" target="_blank" class="text-blue-600 underline">View Image</a>
            </div>

            <input
                type="file"
                id="profileImage"
                ref="profileImageInput"
                accept=".jpg, .jpeg, .png"
                @change="handleFileUpload($event, 'profileImage')"
                class="mt-1 block w-full text-sm text-gray-600 file:mr-4 file:cursor-pointer file:rounded-lg file:border-0 file:bg-blue-50 file:px-4 file:py-2 file:text-sm file:font-semibold file:text-blue-700 hover:file:bg-blue-100 focus:outline-none"
            />
          </div>

          <div>
            <label for="pdfFile" class="block text-sm font-medium text-gray-700">PDF Document Upload</label>

            <div v-if="existingFiles.pdfFile" class="mt-1 mb-2 text-sm text-gray-600">
              Current file:
              <a :href="existingFiles.pdfFile" target="_blank" class="text-blue-600 underline">View PDF</a>
            </div>

            <input
                type="file" id="pdfFile" ref="pdfInput" accept=".pdf" @change="handleFileUpload($event, 'pdfFile')"
                class="mt-1 block w-full text-sm text-gray-600 file:mr-4 file:cursor-pointer file:rounded-lg file:border-0 file:bg-blue-50 file:px-4 file:py-2 file:text-sm file:font-semibold file:text-blue-700 hover:file:bg-blue-100 focus:outline-none"
            />
          </div>
          <div>
            <label for="dwgFile" class="block text-sm font-medium text-gray-700">DWG File Upload</label>

            <div v-if="existingFiles.dwgFile" class="mt-1 mb-2 text-sm text-gray-600">
              Current file:
              <a :href="existingFiles.dwgFile" target="_blank" class="text-blue-600 underline">Download DWG</a>
            </div>

            <input
                type="file" id="dwgFile" ref="dwgInput" accept=".dwg" @change="handleFileUpload($event, 'dwgFile')"
                class="mt-1 block w-full text-sm text-gray-600 file:mr-4 file:cursor-pointer file:rounded-lg file:border-0 file:bg-blue-50 file:px-4 file:py-2 file:text-sm file:font-semibold file:text-blue-700 hover:file:bg-blue-100 focus:outline-none"
            />
          </div>

        </div>

        <div class="mt-8 flex items-center justify-end gap-4 border-t border-gray-100 pt-6">
          <button
              type="button"
              @click="resetForm"
              class="rounded-lg border border-gray-300 bg-white px-6 py-2.5 text-sm font-medium text-gray-700 shadow-sm transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Clear
          </button>
          <button
              type="submit"
              class="rounded-lg bg-blue-600 px-6 py-2.5 text-sm font-medium text-white shadow-sm transition-colors hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Save
          </button>
        </div>

      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'Edit_alu_Profile',
  props: ['sr'], // we have sent this value via url so from there we will get this
  data() {
    return {
      formData: {
        sunrackCode: '',
        genericName: '',
        profileName: '',
        unitWeight: null,
        extruderCode: '',
        status: 'Active',
        profileImage: null,
        pdfFile: null,
        dwgFile: null,
      },
      // Add this to hold the current files from the database
      existingFiles: {
        profileImage: null,
        pdfFile: null,
        dwgFile: null
      }
    };
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    // Captures the file when the user selects it
    handleFileUpload(event, field) {
      const file = event.target.files[0];
      this.formData[field] = file || null;
    },

    resetForm() {
      // Reset the data payload back to defaults
      this.formData = {
        id: null,
        sunrackCode: '',
        genericName: '',
        profileName: '',
        unitWeight: null,
        extruderCode: '',
        status: 'Active',
        profileImage: null,
        pdfFile: null,
        dwgFile: null
      };

      // Clear the actual file names from the HTML input fields visually
      if (this.$refs.profileImageInput) this.$refs.profileImageInput.value = '';
      if (this.$refs.pdfInput) this.$refs.pdfInput.value = '';
      if (this.$refs.dwgInput) this.$refs.dwgInput.value = '';
    },
    gotoDash() {
      this.$router.push({name: 'Aluminium_dash'});
    },
   async createEnq() {
      try {
        let formData = new FormData();

        const profileId = parseInt(this.sr, 10);

        // --- Generate IST Time (Format: DD/MM/YY HH:MM) ---
        const now = new Date();
        const istString = now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" });
        const istDate = new Date(istString);

        const day = String(istDate.getDate()).padStart(2, '0');
        const month = String(istDate.getMonth() + 1).padStart(2, '0');
        const year = String(istDate.getFullYear()).slice(-2); // Get last 2 digits of year
        const hours = String(istDate.getHours()).padStart(2, '0');
        const minutes = String(istDate.getMinutes()).padStart(2, '0');

        const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}`;
        // --------------------------------------------------

        formData.append('sr', profileId);
        formData.append('sunrack_code', this.formData.sunrackCode);
        formData.append('generic_name', this.formData.genericName);
        formData.append('profile_name', this.formData.profileName);
        formData.append('unit_weight', this.formData.unitWeight);
        formData.append('extruder_codes', this.formData.extruderCode);
        formData.append('profile_status', this.formData.status);
        formData.append('last_updated', formattedDate);

        if (this.formData.profileImage) {
          formData.append('profile_image', this.formData.profileImage);
        }
        if (this.formData.pdfFile) {
          formData.append('profile_dime_pdf', this.formData.pdfFile);
        }
        if (this.formData.dwgFile) {
          formData.append('profile_dime_dwg', this.formData.dwgFile);
        }

        const response = await axios.patch(`alumium_db/${this.formData.id}/`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        console.log(response.data);
        this.$router.push({name: 'Aluminium_dash'});

      } catch (error) {
        console.error(error);
        console.log(error.response?.data);
      }
    },
    async fetchData() {
      try {
        const response = await axios.get(`alumium_db/?sr=${this.sr}`)
        const item = response.data[0]

        // Map API response directly to the formData object
        this.formData.id = item.id;
        this.formData.genericName = item.generic_name;
        this.formData.profileName = item.profile_name;
        this.formData.unitWeight = item.unit_weight;
        this.formData.extruderCode = item.extruder_codes;
        this.formData.sunrackCode = item.sunrack_code;
        this.formData.status = item.profile_status || 'Active';

        // Map existing file links/paths
        this.existingFiles.profileImage = item.profile_image; // replace with actual DB column name
        this.existingFiles.pdfFile = item.profile_dime_pdf;   // replace with actual DB column name
        this.existingFiles.dwgFile = item.profile_dime_dwg;
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    }
  },
};
</script>